import React from 'react';
import {useTranslation} from 'react-i18next';

/**
 * SPORT BETBY: lo sportsbook che arriva da Sunshine Hub (sezione sportBetby
 * del catalogo di casino-service), dentro il guscio del sito.
 *
 * La pagina vera sta in aeterium-sport-container, servita da nginx su
 * /sportbetby/ (lvc-infra, comuni/sito-clienti.conf): cerca il gioco Betby,
 * chiede l'indirizzo di avvio col gettone del sito e apre Betby. Qui la si
 * mette in una cornice sotto la testata, cosi' il giocatore resta nel sito
 * (menu, saldo, conto). Stesso dominio: gettone e configurazione sono gli
 * stessi.
 *
 * Nel menu c'e' solo se la skin la accende (backoffice › Skin › Sezioni):
 * di serie e' spenta (catalogo-moduli.json, diSerie: false).
 */
export default function SportBetby() {
  const {t} = useTranslation();
  return (
    <iframe className={'sport-betby'} title={t('Sport Betby')} src={'/sportbetby/'}
      allow={'fullscreen; autoplay'}
      style={{display: 'block', width: '100%', height: 'calc(100vh - var(--lvc-testata, 64px))', minHeight: 480, border: 0}}/>
  );
}
